export const baseOptimuxUrl = `${process.env.REACT_APP_S3_BASE_OPTIMUX_URL}/18_july`;
export const baseUrl = `${process.env.REACT_APP_S3_BASE_URL}/18_july`;

export const ASSETS = {
	heroSectionVideos: [
		{
			id: 'hero_section_1',
			src: `${baseOptimuxUrl}/hero_section/vid_1.mp4?fallbackUrl=${baseUrl}/hero_section/vid_1.mp4`,
			thumbnail: `${baseOptimuxUrl}/hero_section/img_1_compressed.webp?fallbackUrl=${baseUrl}/hero_section/img_1_compressed.webp`,
		},
		{
			id: 'hero_section_2',
			src: `${baseOptimuxUrl}/hero_section/vid_2.mp4?fallbackUrl=${baseUrl}/hero_section/vid_2.mp4`,
			thumbnail: `${baseOptimuxUrl}/hero_section/img_2_compressed.webp?fallbackUrl=${baseUrl}/hero_section/img_2_compressed.webp`,
		},
		{
			id: 'hero_section_3',
			src: `${baseOptimuxUrl}/hero_section/vid_3.mp4?fallbackUrl=${baseUrl}/hero_section/vid_3.mp4`,
			thumbnail: `${baseOptimuxUrl}/hero_section/img_3_compressed.webp?fallbackUrl=${baseUrl}/hero_section/img_3_compressed.webp`,
		},
		{
			id: 'hero_section_4',
			src: `${baseOptimuxUrl}/hero_section/vid_4.mp4?fallbackUrl=${baseUrl}/hero_section/vid_4.mp4`,
			thumbnail: `${baseOptimuxUrl}/hero_section/img_4_compressed.webp?fallbackUrl=${baseUrl}/hero_section/img_4_compressed.webp`,
		},
		{
			id: 'hero_section_5',
			src: `${baseOptimuxUrl}/hero_section/vid_5.mp4?fallbackUrl=${baseUrl}/hero_section/vid_5.mp4`,
			thumbnail: `${baseOptimuxUrl}/hero_section/img_5_compressed.webp?fallbackUrl=${baseUrl}/hero_section/img_5_compressed.webp`,
		},
	],
	characterSectionVideos: [
		{
			id: 'character_video_1',
			src: `${baseOptimuxUrl}/character/vid_1.mp4?fallbackUrl=${baseUrl}/character/vid_1.mp4`,
			thumbnail: `${baseOptimuxUrl}/character/img_1.webp?fallbackUrl=${baseUrl}/character/img_1.webp`,
		},
		{
			id: 'character_video_2',
			src: `${baseOptimuxUrl}/character/vid_2.mp4?fallbackUrl=${baseUrl}/character/vid_2.mp4`,
			thumbnail: `${baseOptimuxUrl}/character/img_2.webp?fallbackUrl=${baseUrl}/character/img_2.webp`,
		},
		{
			id: 'character_video_3',
			src: `${baseOptimuxUrl}/character/vid_3.mp4?fallbackUrl=${baseUrl}/character/vid_3.mp4`,
			thumbnail: `${baseOptimuxUrl}/character/img_3.webp?fallbackUrl=${baseUrl}/character/img_3.webp`,
		},
	],
	productSectionVideos: {
		topSectionVideos: [
			{
				id: 'product_video_1',
				src: `${baseOptimuxUrl}/product/vid_1.mp4?fallbackUrl=${baseUrl}/product/vid_1.mp4`,
				poster: `${baseOptimuxUrl}/product/img_1.webp?fallbackUrl=${baseUrl}/product/img_1.webp`,
			},
			{
				id: 'product_video_2',
				src: `${baseOptimuxUrl}/product/vid_2_.mp4?fallbackUrl=${baseUrl}/product/vid_2_.mp4`,
				poster: `${baseOptimuxUrl}/product/img_2_.webp?fallbackUrl=${baseUrl}/product/img_2_.webp`,
			},
		],
		bottomSectionVideos: [
			{
				id: 'product_video_1',
				src: `${baseOptimuxUrl}/product/vid_3.mp4?fallbackUrl=${baseUrl}/product/vid_3.mp4`,
				poster: `${baseOptimuxUrl}/product/img_3.webp?fallbackUrl=${baseUrl}/product/img_3.webp`,
			},
			{
				id: 'product_video_2',
				src: `${baseOptimuxUrl}/product/vid_4.mp4?fallbackUrl=${baseUrl}/product/vid_4.mp4`,
				poster: `${baseOptimuxUrl}/product/img_4.webp?fallbackUrl=${baseUrl}/product/img_4.webp`,
			},
		],
	},
	fashionSectionVideos: [
		{
			id: 'fashion_video_1',
			src: `${baseOptimuxUrl}/fashion/vid_1.mp4?fallbackUrl=${baseUrl}/fashion/vid_1.mp4`,
			thumbnail: `${baseOptimuxUrl}/fashion/img_1.webp?fallbackUrl=${baseUrl}/fashion/img_1.webp`,
		},
		{
			id: 'fashion_video_2',
			src: `${baseOptimuxUrl}/fashion/vid_2.mp4?fallbackUrl=${baseUrl}/fashion/vid_2.mp4`,
			thumbnail: `${baseOptimuxUrl}/fashion/img_2.webp?fallbackUrl=${baseUrl}/fashion/img_2.webp`,
		},
		{
			id: 'fashion_video_3',
			src: `${baseOptimuxUrl}/fashion/vid_3.mp4?fallbackUrl=${baseUrl}/fashion/vid_3.mp4`,
			thumbnail: `${baseOptimuxUrl}/fashion/img_3.webp?fallbackUrl=${baseUrl}/fashion/img_3.webp`,
		},
	],
};
